<template>
  <div class="modal fade" id="parcelOptionConfigModal" tabindex="-1" role="dialog" style="display: none;">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" id="close" class="close" data-dismiss="modal" aria-label="Close"><span
            aria-hidden="true">×</span></button>
          <h4 class="modal-title"><i class="fa fa-exchange mr-5"></i>{{ 'parcelOptionsConfig' | translate }}</h4>
        </div>
        <div class="modal-body">
          <template v-for="alert in alerts">
            <b-alert :show="alert.dismiss" dismissible :variant="alert.type">
              <h4>
                <i v-if="alert.type == 'success' || alert.type == 'warning' "class="icon fa fa-check"></i>
                <i class="icon fa fa-ban" v-else></i>
                {{'alert_'+alert.type | translate}}!</h4>
              <template v-if="alert.type === 'danger' && alert.message.message === undefined">
                  <span v-for="msg, key in alert.message">
                    {{ msg[0] | translate }}<br>
                  </span>
              </template>
              <template v-else-if="alert.type === 'danger' && alert.message.message !== undefined">
                {{ alert.message.message | translate }}
              </template>
              <template v-else>
                {{alert.message}}
              </template>
            </b-alert>
          </template>
          <div class="row">
            <div class="col-xs-6 mb-10">
              <div class="input-group">
                <label for="weight">{{'weight' | translate}}</label>
                <input type="text" class="form-control" id="weight"
                       :placeholder="'weight' | translate"
                       v-model="modalParcelOption.weight">
              </div>
            </div>
            <div class="col-xs-6 mb-10">
              <div class="input-group">
                <label for="length">{{'length' | translate}}</label>
                <input type="text" class="form-control" id="length"
                       :placeholder="'length' | translate"
                       v-model="modalParcelOption.length">
              </div>
            </div>
            <div class="col-xs-6 mb-10">
              <div class="input-group">
                <label for="width">{{'width' | translate}}</label>
                <input type="text" class="form-control" id="width"
                       :placeholder="'width' | translate"
                       v-model="modalParcelOption.width">
              </div>
            </div>
            <div class="col-xs-6 mb-10">
              <div class="input-group">
                <label for="height">{{'height' | translate}}</label>
                <input type="text" class="form-control" id="height"
                       :placeholder="'height' | translate"
                       v-model="modalParcelOption.height">
              </div>
            </div>
            <div class="col-xs-6 mb-10">
              <div class="input-group">
                <label for="carrier">{{'carrier' | translate}}</label>
                <input type="text" class="form-control" id="carrier"
                       :placeholder="'carrier' | translate"
                       v-model="modalParcelOption.carrier">
              </div>
            </div>
            <div class="col-xs-6 mb-10">
              <div class="input-group">
                <label for="type">{{'parcel_type' | translate}}</label>
                <input type="text" class="form-control" id="type"
                       :placeholder="'parcel_type' | translate"
                       v-model="modalParcelOption.parcel_type">
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" id="confirmEdit" :disabled="errors.any()" class="btn btn-app btn-success"
                  @click="send()"><span class="fa fa-save "></span>{{'save' | translate}}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
    export default {
        props: [
          'modalParcelOption',
          'modalShippingConfig',
          'isNew'
        ],
        data() {
            return {
                alerts: [],
                countryCarrierId: 0,
            }
        },
        methods: {
            send() {
              if (!this.isNew) {
                API.put(`accounting/companies/${this.$route.params.id}/shipping/${this.modalParcelOption.configuration_id}/parcel/${this.modalParcelOption.id}`, this.modalParcelOption)
                  .then($res => {
                    this.alerts.push({dismiss: 4, type: 'success', message: 'success', icon: 'icon fa fa-check', show: true})
                  })
                  .catch(error => {
                    this.alerts.push({dismiss: 4, type: 'danger', message: error.response.data, icon: 'icon fa fa-ban', show: true})
                    this.$emit('newParcelOptionCreated')
                  })
              } else {
                API.post(`accounting/companies/${this.$route.params.id}/shipping/${this.modalShippingConfig.id}/parcel`, this.modalParcelOption)
                  .then(res => {
                    this.alerts.push({dismiss: 4, type: 'success', message: 'success', icon: 'icon fa fa-check', show: true})
                    this.$emit('newParcelOptionCreated')
                  })
                  .catch(error => {
                    this.alerts.push({dismiss: 4, type: 'danger', message: error.response.data, icon: 'icon fa fa-ban', show: true})
                  })
              }
            },
        },
        mounted() {

        }
    }
</script>



// WEBPACK FOOTER //
// src/components/tools/Modals/ParcelOptionConfigModal.vue